import { Middleware } from '@reduxjs/toolkit';

import {
  fetchCertainPaymentMethodFailure,
  fetchCertainPaymentMethodSuccess,
  setFormReady,
} from '@cashier/cashier-data-access';

import {
  getCookie,
  loadPreprocessorResources,
  QaToolKitOptions,
} from '../helpers';

export const paymentMethodMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    const isEnabledHostedField =
      getCookie(QaToolKitOptions.enableHostedField) === 'true';

    if (fetchCertainPaymentMethodSuccess.toString() === action.type) {
      if (isEnabledHostedField) {
        store.dispatch(setFormReady(true));
      } else {
        // TODO delete after testing 2914
        const {
          method: { preprocessor },
        } = action.payload;

        if (preprocessor) {
          loadPreprocessorResources(preprocessor)
            .then(() => {
              store.dispatch(setFormReady(true));
            })
            .catch((error) => {
              store.dispatch(fetchCertainPaymentMethodFailure(error.message));
            });
        } else {
          store.dispatch(setFormReady(true));
        }
      }
    }

    return result;
  };
